import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const Arrow = ({
  width = 55,
  color = 'petroleumGreen',
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 23 15">
      <g id="Symbols">
        <g id="Arrow_down">
          <polyline
            style={{ fill: 'none', stroke: getSemanticTextColor(color), strokeWidth: 3, strokeLinecap: 'round' }}
            className="st0"
            points="21.5,2.5 11.5,12.5 1.5,2.5"
          />
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
